import { useLocation, useNavigate } from "react-router-dom"
import VerticalRule from "../components/VerticalRule"
import FlexColumn from "../layout/FlexColumn"
import PageContainer from "../layout/PageContainer"
import PortfolioCopy from "../layout/PortfolioCopy"
import PortfolioScroller from "../layout/PortfolioScroller"
import { useEffect, useState } from "react"
import { getSelected } from "../utils/nbutils"
import { jpgImport, svgImport } from "../images/SVGImageUtil"
import { section } from "framer-motion/client"

const sectionID = 'writing';

const markdown = `
nico & byrne are multi-disciplinary
***writers*** with numerous projects in
development in ***hollywood***, and the
literary world.
`

const scrollerObject = {
    data : [
        { name : "Summer of 69", 
            slug : "so69",
            hideThumbText : true,
            hero : { altText : "Summer of 69 Cover", image : "jpg/rightcol/so69-inline.jpg", section : sectionID },
            thumbBackground : 'svg/summerof69.svg',
            headline : "SUMMER OF 69", h2 : "Now Streaming on Hulu",
            copy : { 
                text : `Abby is just like any other high school girl. Except sheltered.
Really sheltered. When Abby decides she’s going to 69 the
hottest boy in school, she has no idea where she’s going to
start, so she hires a stripper, Santa Monica, to teach her
everything there is to know about sex.

Summer of 69 is the feature directorial debut of Jillian Bell.
Written by Liz Nico & Jules Byrne and Jillian Bell.
Starring Chloe Fineman, Sam Morelos, Matt Cornett, 
Nicole Byer, Natalie Morales, Liza Koshy, Charlie Day,
Paula Pell, and Alex Moffat.` }
        },
        // { name : "Fruit Loop", slug : "fl", headline : "FRUIT LOOP",
        //     h2: "A Coming of Gay Story",
        //     hideThumbText : true,
        //     hero : { altText : "Fruit Loop Cover", image :"jpg/rightcol/fruitloop-inline.jpg", section : sectionID },
        //     thumbBackground : "svg/fruitloop.svg",
        //     copy : { text: ``, text_hidden : `When Emily Goode finally decides to come out,
        //     she knows it might not go like she wants it to, but
        //     she never imagined she'd wind up stuck in the same day.` }
        //  },
        // { name : "Jane Hates Miranda", slug : "jhm",
        //     headline : "JANE HATES MIRANDA", h2: "Or does she?",
        //     hero : { altText : "Jane Hates Miranda Cover", image : "jpg/rightcol/jhm-inline.jpg", section : sectionID },
        //     hideThumbText : true,
        //     thumbBackground : "svg/janehatesmiranda.svg",
        //     copy : { text:``, text_hidden : `After Jane's mom breaks her foot, Jane has to find another
        //     ride home from California for winter break. A coming of age road-trip
        //     rom-com about two girls who realy get on each other's nerves.` }
        //  },
        // { name : "Blood Moon", slug : "bloodmoon",
        //     hideThumbText : true,
        //     thumbBackground : "svg/bloodmoon.svg",
        //     headline : "BLOOD MOON", h2: "Fates twist and roil in this unique vampire saga.",
        //     copy : { text: ``, text_hidden : `When one of their own is killed for the first time, the secret
        //     society of Vampires is forced to reckon with their past, and an ascendant
        //     enemy that for the first time strikes fear into their hearts.` }
        //  },
        // { name : "Don't Die Hottie", slug : "ddh",
        //     hideThumbText : true,
        //     thumbBackground : "svg/dontdiehottie.svg",
        //     headline : "DON'T DIE HOTTIE", h2 : "I'm Coming to Save You!",
        //     copy : { text : ``, text_hidden : `A buddy comedy about a couple aspiring sleuths who
        //         solve a huge case while looking for a porn star.
        //     ` }
        //  },
        // { name : "The Contest", slug : "thecontest",
        //     hideThumbText : true,
        //     thumbBackground : "svg/TheContest.svg",
        //     headline : "THE CONTEST", h2 : "In a world where inequality is absolute...",
        //     copy : { text : `A sci-fi thriller.
        //     `}
        //  },
        // { name : "Single For Life", slug : "sfl",
        //     hideThumbText : true,
        //     hero : { altText : "Single for Life", image : "jpg/rightcol/sfl-inline.jpg", section : sectionID },
        //     thumbBackground : "svg/singleforlife.svg",
        //     headline : "SINGLE FOR LIFE", h2 : "She hasn't had a relationship in 2000 years.",
        //     copy : { text : `A rom-com of godly proportions.
        //     ` }
        //  },
    ],
    selected : "",
    section : sectionID,
}

const mkSlugTree = (arr) => {
    const nst = {};
    for ( let i = 0; i < arr.length; i ++ ) {
        nst[arr[i].slug] = arr[i];
    }
    return nst;
}

const WritingPage = () => {

    const slugTree = mkSlugTree(scrollerObject.data);
    const navigate = useNavigate();

    const loc = useLocation();
    const initPath = getSelected(loc.pathname);

    const [selected, setSelected] = useState(initPath);

    //console.log("initial path", loc.pathname, getSelected(loc.pathname));

    scrollerObject.selected = getSelected(loc.pathname);

    const ue = useEffect(() => {
        const nselected = getSelected(loc.pathname);
        setSelected(nselected);
        if ( initPath.toLowerCase() === sectionID || initPath === "" ) {
            navigate(`/${sectionID}/${scrollerObject.data[0].slug}`);
        }
        scrollerObject.selected = nselected;
    }, [loc, initPath, navigate])

    return (
        <PageContainer>
            <FlexColumn key={"column_left"} widthClass={"w30"}>
                <PortfolioScroller
                    thumbScroller={scrollerObject} 
                    textArea={{ 
                        text : markdown, 
                        styleRules : { mod : "writing" } }} />
            </FlexColumn>
            <FlexColumn key={"vertical_rule"} widthClass={"vertical_rule"}>
                <VerticalRule />
            </FlexColumn>
            <FlexColumn key={"colum_right"} widthClass={"rightcol"}>
                <PortfolioCopy {...slugTree[selected]} />
            </FlexColumn>
        </PageContainer>
    )
}

export default WritingPage;